import { useRecoilState } from 'recoil';
import * as Atom from '../recoil';
import { fetchCompanyInfo } from '../../infra/api/fetchCompanyInfo';
import useToast from '../hooks/useToast';
import useModal from './useModal';

const useCompanySearch = () => {
  const { addToast } = useToast();
  const [personal] = useRecoilState(Atom.personalInfo);

  const searchCompany = async (companyName: any) => {
    if (!companyName.trim()) {
      addToast('회사명을 다시 입력해 주세요.');
      return;
    }

    const res: any = await fetchCompanyInfo({
      trackCd: personal.trackCd,
      transactionNo: personal.transactionNo,
      authToken: personal.authToken,
      condition: {
        compNm: companyName ?? '',
        page: 1,
        rowsPerPage: 15,
      },
    });
    if (!res.data.isSucceed && res.data.resultMessage) {
      addToast(res.data.resultMessage);
      return;
    }
    return res?.data?.result;
  };

  const {
    isOpen: isOpenSearchBottomsheet,
    open: openSearchBottomsheet,
    close: closeSearchBottomsheet,
  } = useModal();
  const {
    isOpen: isOpenInBizBottomsheet,
    open: openInBizBottomsheet,
    close: closeInBizBottomsheet,
  } = useModal();
  const closeSearchAndInBizBottomsheet = () => {
    closeSearchBottomsheet();
    closeInBizBottomsheet();
  };

  return {
    searchCompany,
    //
    //
    //
    isOpenSearchBottomsheet,
    openSearchBottomsheet,
    closeSearchBottomsheet,
    isOpenInBizBottomsheet,
    openInBizBottomsheet,
    closeInBizBottomsheet,
    closeSearchAndInBizBottomsheet,
  };
};

export default useCompanySearch;
